import makeTable from '../../components/makeTable.jsx';

export const UrlTable = makeTable([
  ['URL', 60],
  ['Outbound', 10],
  ['Url Rank', 10],
  ['Failing metrics', 10],
  ['Status', 10],
]);
